































































import {Component} from "vue-property-decorator";
import routenames from "@/modules/vRoutedefs";
import CommonBase from "../../CommonBase";
import {MaxSquareMetersAllowed} from "@/modules/mapmodels";

@Component
export default class LocationSetup extends CommonBase {
    rn = routenames;

    readonly maxSquareMeters = MaxSquareMetersAllowed;

    get maxSquareKm2() {
        return this.maxSquareMeters/1000000;
    }
}
